import { useMutation, useQuery, useQueryClient } from "react-query";
import { getDistribution, saveDistribution } from "@/api/Histories/distribution-api";

const key = "io-distribution";

export function useIODistribution(applicationHistoryId, options = {}) {
	return useQuery([key, applicationHistoryId], () => getDistribution(applicationHistoryId), {
		enabled: !!applicationHistoryId,
		...options,
	});
}

export function useSaveIODistribution(applicationHistoryId, listType = null, filters = null) {
	const queryClient = useQueryClient();

	return useMutation((businessCenters) => saveDistribution(applicationHistoryId, businessCenters, listType, filters), {
		onSuccess: (response) => {
			if (response?.updated_data && listType && filters) {
				const { data, total } = response.updated_data;

				queryClient.setQueryData(["histories", "list", listType, filters], (oldData) => {
					if (!oldData) return { data, total };
					return { ...oldData, data, total };
				});
			}

			queryClient.invalidateQueries([key, applicationHistoryId]);
		},
	});
}
